import { useEffect } from 'react';

import { useAutoLinkContext } from '@betterment/js-runtime';
import { datadogLogs } from '@datadog/browser-logs';
import { useLocation } from 'react-router-dom';

export function useMetricsLogger() {
  const { pathname, search } = useLocation();
  const { matchReactRoute } = useAutoLinkContext();

  useEffect(() => {
    const match = matchReactRoute(`/app${pathname}`);
    if (match) {
      datadogLogs.logger.info('ReactRoute', {
        route: {
          pathname: convertPathnameToPattern(pathname),
        },
      });
    }
  }, [pathname, search, matchReactRoute]);
}

export function convertPathnameToPattern(pathname: string) {
  const fullPathName = pathname
    .split('/')
    .map(path => {
      if (/^(401k|[^\d]*)$/.test(path)) {
        return path;
      }
      return '{num}';
    })
    .join('/');
  return `/app${fullPathName}`.replace(/\/$/, '');
}
